import { makeAnglePositive } from "functions/sketch/math";

export function getNextAngleOnFirstHalfCornerSeam(cut_angle: number, angle: number): number {
    return makeAnglePositive(Math.round(((cut_angle - 90 - angle) * 2 + angle) * 100) / 100, false);
}

export function getAngleOnSecondHalfCornerSeam(cut_angle: number, next_angle: number): number {
    return makeAnglePositive(Math.round(((cut_angle - 90 - next_angle) * 2 + next_angle) * 100) / 100, false);
}